<template lang="pug">
	.campaign-picker-wrapper
		button.btn.btn-primary(v-pseudo-modal-show="'campaign-picker-dropdown'")
			span Add Filter
		.campaign-picker(v-pseudo-modal="'campaign-picker-dropdown'" ref="picker")
			.search
				input(v-model="searchValue" placeholder='Search')
				i.fa.fa-search
			.campaigns-top
				.left
					span {{campaigns.filter(c => c.name.toLowerCase().includes(searchValue.toLowerCase())).length + ' Campaigns'}}
				.right
					span(@click="selectAll(true)") Deselect All
					span(@click="selectAll()") Select All
			.campaigns-list
				.campaign(v-for="campaign in campaigns.filter(c => c.name.toLowerCase().includes(searchValue.toLowerCase()))")
					i.fa.fa-square(v-if="!campaign.checked" @click="checkCampaign(campaign)")
					i.fa.fa-check-square(v-else @click="checkCampaign(campaign)")
					span {{campaign.name}}
			.campaigns-bottom
				.left
					button.btn.btn-cancel(@click="cancel") Cancel
				.right
					button.btn.btn-confirm(@click="apply") Apply

</template>

<script>

import Screen from "@/mixins/screen";
import {Server} from "@/services/Server";

export default {
	name: 'CampaignPicker',
	mixins: [Screen],
	screen: {
		updateOn: ['Campaigns Loaded'],
		events: {}
	},
	props: ['updateFunction'],
	data() {
		this.campaigns = [];
		return {
			showed: true,
			searchValue: ''
		}
	},
	mounted() {
		Broadcast.on("Pseudo Modal Showed campaign-picker-dropdown", () => {
			this.$nextTick(() => {
				let picker = this.$refs.picker;
				if (!picker) return;
				this.searchValue = '';
				picker.style.removeProperty('transform');
				if (picker.getBoundingClientRect().right > window.innerWidth) {
					picker.style.transform = `translateX(${window.innerWidth - picker.getBoundingClientRect().right}px)`;
				}
			});
		}, 'campaign-picker');
	},
	created() {

	},
	methods: {
		collectData() {
			this.campaigns = [...Object.values(Order.Campaigns)];
		},
		checkCampaign(campaign) {
			campaign.checked = !campaign.checked;
			this.$forceUpdate();
		},
		selectAll(revert = false) {
			this.campaigns.filter(campaign => campaign.name.toLowerCase().includes(this.searchValue.toLowerCase())).forEach(campaign => campaign.checked = !revert);
			this.$forceUpdate();
		},
		cancel() {
			this.$refs.picker.style.display = 'none';
		},
		apply() {
			this.updateFunction(this.campaigns.filter(campaign => campaign.checked));
			this.$refs.picker.style.display = 'none';
		}
	}
}

</script>

<style lang="sass">

.campaign-picker-wrapper
	position: relative
	padding-left: 15px

	>button.btn.btn-primary
		border: 2px solid #66609d
		border-radius: 15px
		background: unset
		color: #aaa1f5
		height: 100%

.campaign-picker
	display: flex
	flex-direction: column
	position: absolute
	top: 40px
	left: 10px
	background-color: #3a3b4a
	width: 350px
	border-radius: 10px

	>.search
		display: flex
		flex-direction: row
		border-bottom: 1px solid black

		>input
			background-color: unset
			border: 0
			height: 30px
			padding-left: 10px
			width: 100%
			color: white

			&:focus
				outline: none

		>i
			font-size: 15px
			display: flex
			margin: auto
			padding-right: 10px
			color: #9397da

	>.campaigns-top
		display: flex
		justify-content: space-between
		align-items: center
		color: white
		border-bottom: 1px solid black
		padding: 10px 0

		>.left
			display: flex
			padding-left: 10px

		>.right
			display: flex
			font-weight: bold
			gap: 15px
			padding-right: 10px

			>span
				cursor: pointer

	>.campaigns-bottom
		display: flex
		justify-content: space-between
		align-items: center
		color: white
		padding: 10px 0

		>.left
			display: flex
			padding-left: 10px
			font-weight: bold

			>span
				cursor: pointer

		>.right
			display: flex
			font-weight: bold
			gap: 15px
			padding-right: 10px

			>span
				cursor: pointer

	>.campaigns-list
		padding: 5px 10px
		font-size: 16px
		display: flex
		flex-direction: column
		gap: 5px
		max-height: 350px
		overflow: hidden auto
		border-bottom: 1px solid black

		&::-webkit-scrollbar
			appearance: none
			width: 5px
		&::-webkit-scrollbar-thumb
			background-color: #343434
			border-radius: 15px

		>.campaign
			color: white
			display: flex
			flex-direction: row
			gap: 10px
			align-items: center

			>i.fa
				color: #9694de
				cursor: pointer
				font-size: 25px


</style>
